import { StoryStatusResponse } from "@/app/api/story/status/route";
import { ContactCharacter, PlayerCharacter, StoryCharacter, StoryLocation, StoryUniverse } from "@/lib/types/story";
import { getCurrentBearerToken } from "./client-auth";
import { SupportTicket } from "@/components/Types";
import { StoryTransferResponse } from "@/app/api/story/[storyId]/transfer/route";

async function getStoryUniverse({universeId}: {universeId: string}): Promise<StoryUniverse | null> {
    // TODO

    return null;
}

async function getStoryLocation({universeId, locationId}: {universeId: string, locationId: string}): Promise<StoryLocation | null> {
    // TODO

    return null;
}

async function getAvailableLocations({universeId}: {universeId: string}): Promise<Partial<StoryLocation>[] | null> {
    try {
        const response = await fetch(`/api/story/${universeId}/available-locations`, {
            method: 'GET',
            headers: {
                'Authorization': getCurrentBearerToken()
            }
        });

        const data = await response.json();

        if (data.locations) {
            return data.locations as StoryLocation[];
        } else if (data.error) {
            throw new Error(data.error);
        } else {
            throw new Error('Unknown error');
        }
    } catch (error) {
        console.error(error);
        throw error;
    }
}

async function getPlayerCharacter({universeId}: {universeId: string}): Promise<PlayerCharacter | null> {
    try {
        const response = await fetch(`/api/story/${universeId}/player/character`, {
            method: 'GET',
            headers: {
                'Authorization': getCurrentBearerToken()
            }
        });

        const data = await response.json();

        if (data.playerCharacter) {            
            return data.playerCharacter as PlayerCharacter;
        } else if (data.error) {
            throw new Error(data.error);
        } else {
            throw new Error('Unknown error');
        }
    } catch (error) {
        console.error(error);
        throw error;
    }
}

async function getContactCharacter({characterId}: {characterId: string}): Promise<ContactCharacter | null> {
    try {
        const response = await fetch(`/api/contacts/character/${characterId}`, {
            method: 'GET',
            headers: { 'Authorization': getCurrentBearerToken() }
        });

        const data = await response.json();

        if (data.character) {
            return data.character as ContactCharacter;
        } else if (data.error) {
            throw new Error(data.error);
        } else {
            throw new Error('Unknown error');
        }
    } catch (error) {
        console.error(error);
        throw error;
    }
}

async function getStatus() : Promise<StoryStatusResponse> {
    try {
        const response = await fetch(`/api/story/status`, {
            method: 'GET',
            headers: {
                'Authorization': getCurrentBearerToken()
            }
        });

        const data = await response.json();

        if (data.error) {
            throw new Error(data.error);
        }

        return data as StoryStatusResponse;
    } catch (error) {
        console.error(error);
        throw error;
    }
}

async function transferPlayerCharacter({storyId, locationId}: {storyId: string, locationId: string}): Promise<StoryTransferResponse> {  
    try {
        const response = await fetch(`/api/story/${storyId}/transfer`, {
            method: 'POST',
            headers: { 'Authorization': getCurrentBearerToken() },
            body: JSON.stringify({ locationId })
        });

        const data = await response.json();

        if (data.error) {
            throw new Error(data.error);
        }

        return data as StoryTransferResponse;
    } catch (error) {
        console.error(error);
        throw error;
    }
}

async function getLocationCharacters({storyId, locationId}: {storyId: string, locationId: string}): Promise<StoryCharacter[] | null> {
    try {
        const response = await fetch(`/api/story/${storyId}/location/${locationId}/characters`, {
            method: 'GET',
            headers: { 'Authorization': getCurrentBearerToken() }
        });

        const data = await response.json();

        if (data.characters) {
            return data.characters.map((character: any) => character as StoryCharacter);
        } else if (data.error) {
            throw new Error(data.error);
        } else {
            throw new Error('Unknown error');
        }
    } catch (error) {
        console.error(error);
        throw error;
    }
}

export const storyFrontendApi = {
    getStatus,
    getPlayerCharacter,
    transferPlayerCharacter,
    getAvailableLocations,
    getLocationCharacters,

    // Semantic aliases:
    characters: {
        getLocationCharacters,
        getPlayerCharacter,
        transferPlayerCharacter,
        getContactCharacter,
    },
    locations: {
        getAvailableLocations,
        getLocationCharacters,
    }
}